module.exports = __webpack_public_path__ + "img/machine-learning.af15e895.png";